import React from "react"
import PropTypes from "prop-types"
import Grid from "../../grid"
import { H2, P } from "../../typography"
import { Span, A } from "./styles"
import Button from "../../button"

const LinkedApplication = ({ linked_application, toggleProfile }) => {
  const name = linked_application?.linked_person?.name
  const otherName = linked_application?.linked_person?.linked_name
  if (!name || !otherName) return null

  return (
    <>
      <H2 variant="primary" profile>
        Linked Application
      </H2>

      {linked_application?.show_link && toggleProfile !== undefined ? (
        <>
          <Span>
            <Button
              onClick={(event) => toggleProfile(event, linked_application?.linked_person)}
              variant="primary"
              size="small"
              outlined
            >
              Open {linked_application?.linked_person?.name} profile
            </Button>
          </Span>

          <P marginless variant="content" profileData>
            {linked_application?.show_link && toggleProfile !== undefined ? (
              <A onClick={(event) => toggleProfile(event, linked_application?.linked_person)}>
                {linked_application?.linked_person?.name}{" "}
              </A>
            ) : (
              `${linked_application?.linked_person?.name} `
            )}
            and {linked_application?.linked_person?.linked_name} have linked their applications as they would like to
            participate on the program together.
          </P>
        </>
      ) : (
        <P marginless variant="content" profileData>
          {linked_application?.linked_person?.name} and {linked_application?.linked_person?.linked_name} have linked
          their applications, but {linked_application?.linked_person?.name}'s profile is currently unavailable.
        </P>
      )}
    </>
  )
}

LinkedApplication.propTypes = {
  linked_application: PropTypes.object.isRequired,
  toggleProfile: PropTypes.func
}

LinkedApplication.defaultProps = {
  linked_application: {},
  toggleProfile: undefined
}

export default LinkedApplication
